import React, { useEffect, useState } from "react";
import {
  Box,
  Container,
  VStack,
  Text,
  Heading,
  useToast,
  Spinner,
  Button,
  useColorModeValue,
} from "@chakra-ui/react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { authAPI } from "../services";
import { useTranslation } from "react-i18next";
import { PublicNavbar } from "./layout/PublicNavbar";
import { Footer } from "./layout/Footer";

export const VerifyEmail: React.FC = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [isVerified, setIsVerified] = useState(false);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const toast = useToast();
  const { t } = useTranslation();
  const bgColor = useColorModeValue("gray.50", "gray.900");

  useEffect(() => {
    const verifyEmail = async () => {
      const token = searchParams.get("token");
      if (!token) {
        toast({
          title: t("auth.verificationError"),
          description: t("auth.verificationTokenMissing"),
          status: "error",
          duration: 5000,
          isClosable: true,
        });
        setIsLoading(false);
        return;
      }

      try {
        await authAPI.verifyEmail(token);
        setIsVerified(true);
        toast({
          title: t("auth.verificationSuccess"),
          status: "success",
          duration: 3000,
          isClosable: true,
        });
      } catch (error) {
        toast({
          title: t("auth.verificationError"),
          description: error instanceof Error ? error.message : String(error),
          status: "error",
          duration: 5000,
          isClosable: true,
        });
      } finally {
        setIsLoading(false);
      }
    };

    verifyEmail();
  }, [searchParams, toast, t]);

  return (
    <Box minH="100vh" display="flex" flexDirection="column">
      <PublicNavbar />

      <Box flex="1" bg={bgColor} py={20}>
        <Container maxW="container.sm" mt={20}>
          <VStack spacing={8} textAlign="center">
            <Heading
              size="2xl"
              fontFamily="Nasalization"
              bgGradient="linear(to-r, brand.primary, brand.secondary)"
              bgClip="text"
            >
              {t("auth.emailVerification")}
            </Heading>

            {isLoading ? (
              <Spinner size="xl" />
            ) : (
              <VStack spacing={6}>
                <Text fontSize="lg">
                  {isVerified
                    ? t("auth.verificationSuccess")
                    : t("auth.verificationFailed")}
                </Text>

                <Button
                  colorScheme="brand"
                  size="lg"
                  onClick={() => navigate("/login")}
                >
                  {t("auth.backToLogin")}
                </Button>
              </VStack>
            )}
          </VStack>
        </Container>
      </Box>

      <Footer />
    </Box>
  );
};
